module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w5-file-component",
    attrs: {
      "name": _vm.name
    },
    on: {
      "click": _vm.clearErrors
    }
  }, [(_vm.currentValue && typeof _vm.currentValue === 'object') ? _c('div', {
    staticClass: "w5-file-uploader-item"
  }, [_c('div', {
    staticClass: "w5-file-uploader-item-image-wrapper"
  }, [_c('div', {
    staticClass: "attach-no-image-preview-file-uploader"
  }, [_vm._v(_vm._s(_vm.currentValue.ext))])]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-title"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.currentValue.title)))]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-size"
  }, [((_vm.currentValue.status === '' || _vm.currentValue.status === 'done') && _vm.currentValue.size) ? _c('span', [_vm._v(_vm._s(_vm._f("bytes")(_vm.currentValue.size)))]) : _vm._e(), _vm._v(" "), (_vm.currentValue.status === 'loading' || _vm.currentValue.status === 'uploading') ? _c('span', {
    staticClass: "font-size-85"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading-hor16.gif"
    }
  }), _c('br'), _vm._v(_vm._s(_vm.currentValue.progress ? _vm.currentValue.progress : ''))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "w5-file-uploader-item-buttons"
  }, [(_vm.currentValue.status === 'done') ? _c('font-awesome-icon', {
    attrs: {
      "title": _vm._f("ftc")('main/delete'),
      "icon": "trash-alt"
    },
    on: {
      "click": _vm.deleteItem
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentValue.status === 'loading' || _vm.currentValue.status === 'uploading') ? _c('font-awesome-icon', {
    attrs: {
      "title": _vm._f("ftc")('main/cancel'),
      "icon": "times-circle"
    },
    on: {
      "click": _vm.cancelUploading
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buttonVisibility),
      expression: "buttonVisibility"
    }],
    staticClass: "w5-file-add-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "paperclip"
    }
  }), _c('div', {
    staticClass: "w5-file-add-button-caption"
  }, [_vm._v(_vm._s(_vm.buttonTitle))]), _vm._v(" "), _c('input', {
    ref: "fileUploaderInput",
    attrs: {
      "type": "file",
      "name": "w5-file-uploader"
    },
    on: {
      "change": _vm.onSelect
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors !== ''),
      expression: "errors !== ''"
    }, {
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.errors)),
      expression: "localeFtc(errors)"
    }],
    staticClass: "alert alert-danger w5-alert-valid",
    attrs: {
      "role": "alert"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a707178"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/directFile.vue
// module id = 357
// module chunks = 0